import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Layout from './components/Layout';
import Report from './deposits/report';
import Filters from './filters/FiltersContainer';
import ExportableReport from './ExportableReport';
import QuickBooksSettings from './deposits/quickBooks/containers/QuickBooksSettings';
import { getIsRentalBarber, isBarberUser } from '../../auth/selectors';

export const DEPOSIT_REPORT_EXPORT_DAYS = 7;

const DepositsReport = ({
  downloadCsv,
  canLoadReport,
  exportReportDays,
  isBarber,
  isRentalBarber,
  disableDownloadButton,
}) => (
  <Layout title="Deposits">
    <div className="layout">
      <div className="layout__item u-4/6">
        <Filters
          disableDownloadButton={disableDownloadButton}
          csv={downloadCsv}
          disableBarberFilter
          showCsvExport={canLoadReport}
        />
      </div>
      <div className="layout__item u-2/6 u-mt- u-text-right">
        <QuickBooksSettings display-if={!isBarber || isRentalBarber} />
      </div>
    </div>
    <ExportableReport
      canLoadReport={canLoadReport}
      name="deposits-report"
      label="Deposits report"
      exportReportDays={exportReportDays}
    >
      <Report tableAutomationId="table:depositsReport" />
    </ExportableReport>
  </Layout>
);

const mapStateToProps = state => ({
  shop: state.auth.shop,
  isBarber: isBarberUser(state),
  isRentalBarber: getIsRentalBarber(state),
  disableDownloadButton: !state.reports.depositsReport || state.reports.depositsReport.length === 0,
});

DepositsReport.propTypes = {
  canLoadReport: PropTypes.bool.isRequired,
  downloadCsv: PropTypes.func.isRequired,
  exportReportDays: PropTypes.number.isRequired,
  disableDownloadButton: PropTypes.bool.isRequired,
  isBarber: PropTypes.bool.isRequired,
  isRentalBarber: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(DepositsReport);
